export default __webpack_public_path__ + "static/view_02-25_1-229fc816fab0accc17b718e17a703d51.jpg";